import styled from "styled-components";

export const StyledSearchCollaboratorsOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
